import { DOCUMENT_RULES_UI_SECTIONS } from '../../models/enums.model';
import {
	SubjectLayout,
	NeighborhoodLayout,
	ImprovementsLayout,
	SalesApproachLayout,
	CostApproachLayout,
	IncomeApproachLayout,
	ReconciliationLayout
} from './1004';
import {
	Subject1073Layout,
	Neighborhood1073Layout,
	ProjectInformation1073Layout,
	ProjectAnalysis1073Layout,
	UnitDescription1073Layout,
	SalesApproach1073Layout
} from './1073';
import { ProjectAnalysis1075Layout, UnitDescription1075Layout } from './1075';
import { Improvements2055Layout } from './2055/improvements.layout';
import {
	ArrivalLayout,
	SiteLayout
} from './cvds/v3';
import {
	Room32Layout,
	Feature32Layout,
	Update32Layout
} from './cvds/v3.2';
import {
	Room33Layout
} from './cvds/v3.3';

export class LayoutPages {
	pages = {
		'CVReview:1': {
			subject: {
				layout: SubjectLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SUBJECT
			},
			neighborhood: {
				layout: NeighborhoodLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.NEIGHBORHOOD
			},
			improvements: {
				layout: ImprovementsLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.IMPROVEMENTS
			},
			salesapproach: {
				layout: SalesApproachLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SALESAPPROACH
			},
			costapproach: {
				layout: CostApproachLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.COSTAPPROACH
			},
			incomeapproach: {
				layout: IncomeApproachLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.INCOMEAPPROACH
			},
			reconciliation: {
				layout: ReconciliationLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.RECONCILIATION
			}
		},
		'CVReview1073:1': {
			subject: {
				layout: Subject1073Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SUBJECT
			},
			neighborhood: {
				layout: Neighborhood1073Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.NEIGHBORHOOD
			},
			projectinformation: {
				layout: ProjectInformation1073Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.PROJECTINFORMATION
			},
			projectanalysis: {
				layout: ProjectAnalysis1073Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.PROJECTANALYSIS
			},
			unitdescription: {
				layout: UnitDescription1073Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.UNITDESCRIPTION
			},
			salesapproach: {
				layout: SalesApproach1073Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SALESAPPROACH
			},
			incomeapproach: {
				layout: IncomeApproachLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.INCOMEAPPROACH
			},
			reconciliation: {
				layout: ReconciliationLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.RECONCILIATION
			}
		},
		'CVReview1075:1': {
			subject: {
				layout: Subject1073Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SUBJECT
			},
			neighborhood: {
				layout: Neighborhood1073Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.NEIGHBORHOOD
			},
			projectinformation: {
				layout: ProjectInformation1073Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.PROJECTINFORMATION
			},
			projectanalysis: {
				layout: ProjectAnalysis1075Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.PROJECTANALYSIS
			},
			unitdescription: {
				layout: UnitDescription1075Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.UNITDESCRIPTION
			},
			salesapproach: {
				layout: SalesApproach1073Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SALESAPPROACH
			},
			incomeapproach: {
				layout: IncomeApproachLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.INCOMEAPPROACH
			},
			reconciliation: {
				layout: ReconciliationLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.RECONCILIATION
			}
		},
		'CVReview2055:1': {
			subject: {
				layout: SubjectLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SUBJECT
			},
			neighborhood: {
				layout: NeighborhoodLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.NEIGHBORHOOD
			},
			improvements: {
				layout: Improvements2055Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.IMPROVEMENTS
			},
			salesapproach: {
				layout: SalesApproachLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SALESAPPROACH
			},
			costapproach: {
				layout: CostApproachLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.COSTAPPROACH
			},
			incomeapproach: {
				layout: IncomeApproachLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.INCOMEAPPROACH
			},
			reconciliation: {
				layout: ReconciliationLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.RECONCILIATION
			}
		},
		'InspectionReport:3': {
			arrival: {
				layout: ArrivalLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SUBJECT
			},
			site: {
				layout: SiteLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SUBJECT
			}
		},
		'InspectionReport:3.2': {
			room: {
				layout: Room32Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SUBJECT
			},
			feature: {
				layout: Feature32Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SUBJECT
			},
			update: {
				layout: Update32Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SUBJECT
			}
		},
		'InspectionReport:3.3': {
			room: {
				layout: Room33Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SUBJECT
			}
		}
	};
}
